/**
 * 维保报告版本选择查询
 */
import React from 'react';

import { Modal, Radio, Row, Divider, Descriptions } from 'antd';

//http请求
import http from '../../../axios/http';
//加载中遮罩
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';

class MaintenanceSelect extends React.Component {

    state = {
        fees: {
            base: 0,
            knock: 0,
            comp: 0,
        },
        reportType: 1, //维保报告类型
        reportIndex: 0, //选择了的共享报告顺序

        loadingVisible: false,
    }

    componentDidMount() {
        http.get({
            url: '/maintenance/findMaintenanceFees',
            data: {},
            success: (res) => {
                if (res != null) {
                    let base = parseInt(res["base"]);
                    let knock = parseInt(res["knock"]);
                    let comp = parseInt(res["comp"]);
                    this.setState({ fees: { base, knock, comp } });
                }
            }
        });
    }

    searchReport = () => {
        this.setState({ loadingVisible: true });
        const editData = this.props.editData;
        let data = {
            "reportType": this.state.reportType,
            "vin": editData.vin,
            "plateNo": editData.plateNo,
            "engineNo": editData.engineNo,
        };
        //是否有共享分析报告的选择
        let shareReportFlag = editData["code"] === 1 && editData["middleAgentList"] != null && editData["middleAgentList"].length > 0;
        //计算费用
        let baseFees = this.state.fees.base;
        if (shareReportFlag && this.state.reportIndex > -1) {
            baseFees = editData["middleAgentList"][this.state.reportIndex]["price"];
            data["middleAgentUserId"] = editData["middleAgentList"][this.state.reportIndex]["middleAgentUserId"];
        }
        data["price"] = baseFees;
        if (this.state.reportType === 1) {
            data["price"] = (this.state.fees.knock * 100 + baseFees * 100) / 100;
        }
        this.searchBrand(data.vin,
            ({ brand, brandId }) => {
                data.brand = brand;
                data.brandId = brandId;
                http.post({
                    url: '/maintenance/findVehicleMaintenance',
                    data: data,
                    success: (res) => {
                        if (res.code === 0) {
                            messager.notify(res.msg, "异常", "error");
                        } else {
                            messager.notify("已发起查询！");
                            if (this.props.successCallback) {
                                this.props.successCallback(this.props.queryData);
                            }
                            this.props.onCancel();
                        }
                        this.setState({ loadingVisible: false });
                    },
                    error: (res) => {
                        messager.alert(res, "异常", "error");
                        this.setState({ loadingVisible: false });
                    }
                });
            });
    }

    //查询品牌
    searchBrand = (vin, callback) => {
        http.get({
            url: '/mall/vehicle/vin/query',
            data: {
                vin: vin,
                apiType: 'chaboshi',
            },
            success: (res) => {
                let data = {
                    brand: '查无品牌',
                    brandId: '0'
                };
                if (res !== null) {
                    data = {
                        brand: res.brand + " " + res.typeName,
                        brandId: res.id
                    };
                }
                callback(data);
            }
        })
    }

    reportIndexChange = (e) => {
        let index = e.target.value;
        this.setState({ reportIndex: index });
        if (index === -1) {
            this.setState({ reportType: 1 });
        }
    }

    render() {
        const { visible, onCancel, editData } = this.props;
        //是否有共享分析报告的选择
        let shareReportFlag = editData["code"] === 1 && editData["middleAgentList"] != null && editData["middleAgentList"].length > 0;
        //是否有维保报告可选择
        let maintenanceReportDisabled = editData["code"] === 0 || (shareReportFlag && this.state.reportIndex === -1);
        //计算费用
        let baseFees = this.state.fees.base;
        if (shareReportFlag && !maintenanceReportDisabled) {
            baseFees = editData["middleAgentList"][this.state.reportIndex]["price"];
        }
        let knockFees = (this.state.fees.knock * 100 + baseFees * 100) / 100;
        return (
            <Modal
                visible={visible}
                title="车辆维保报告查询"
                okText="查询"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.searchReport}
                afterClose={() => {
                    this.setState({
                        reportType: 1, //维保报告类型
                        reportIndex: 0, //选择了的共享报告顺序
                    });
                }}
            >
                <Divider orientation="left">车辆信息</Divider>
                <Row>
                    <Descriptions column={2}>
                        <Descriptions.Item label="车架号">{editData.vin}</Descriptions.Item>
                        <Descriptions.Item label="车牌号">{editData.plateNo}</Descriptions.Item>
                        <Descriptions.Item label="发动机号">{editData.engineNo}</Descriptions.Item>
                    </Descriptions>
                </Row>
                {
                    !shareReportFlag ? "" :
                        <Radio.Group onChange={this.reportIndexChange} value={this.state.reportIndex}>
                            <Divider orientation="left">共享数据分析报告选择</Divider>
                            {editData["middleAgentList"].map((item, index) => {
                                return <Radio key={index} value={index} style={{ width: "100%", padding: '5px 0' }}>
                                    <span style={{ width: '40%', display: 'inline-block' }}>共享数据分析报告{index + 1}</span>
                                    <span style={{ width: '30%', display: 'inline-block', color: '#DDDDDD' }}>平均时长{Math.ceil(item["brandAvgTime"] / 60)}分钟</span>
                                    <span style={{ width: '25%', display: 'inline-block', textAlign: 'right' }}>￥{item["price"]}</span>
                                </Radio>
                            })}
                            <Row><Radio value={-1}>不使用共享分析报告</Radio></Row>
                        </Radio.Group>
                }
                <Divider orientation="left">维保订单选择</Divider>
                <Radio.Group onChange={(e) => { this.setState({ reportType: e.target.value }) }} value={this.state.reportType}>
                    <Radio value={0} style={{ width: "100%", padding: '5px 0' }} disabled={maintenanceReportDisabled}>
                        <span style={{ width: '40%', display: 'inline-block' }}>历史车况——维保版</span>
                        <span style={{ width: '30%', display: 'inline-block', color: '#DDDDDD' }}>{maintenanceReportDisabled ? '暂不支持查询' : ''}</span>
                        <span style={{ width: '25%', display: 'inline-block', textAlign: 'right' }}>￥{baseFees}</span>
                    </Radio>
                    <Radio value={1} style={{ width: "100%", padding: '5px 0' }}>
                        <span style={{ width: '50%', display: 'inline-block' }}>历史车况——综合版（维保/碰撞）</span>
                        <span style={{ width: '45%', display: 'inline-block', textAlign: 'right' }}>￥{knockFees}</span>
                    </Radio>
                </Radio.Group>
                <Row>综合版包括两种数据(维保数据{baseFees}元，碰撞数据{this.state.fees.knock}元)。按报告内容包含的数据种类收费。</Row>
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据处理中..."
                />
            </Modal>

        );
    }
}

export default MaintenanceSelect;